// extracted by mini-css-extract-plugin
export default {"home":"home_home__qA4gR","socialIconGroup":"home_socialIconGroup__0cZ-s","socialIcon":"home_socialIcon__4YqAd","workExperiences":"home_workExperiences__pALDg"};